module.exports = __webpack_public_path__ + "static/media/payment_method_edit.6a1c80ff.svg";